import { useFeatureGoogleAnalytics } from '../../../../shared_app/hooks/useFeatureGoogleAnalytics';
var YD_EVENT_CATEGORY = 'YearlyDashboard';
var YearlyDashboardEvents = {
    pageView: YD_EVENT_CATEGORY + "_Open",
    diagramsPieChartHover: YD_EVENT_CATEGORY + "_PieCharts_Hover",
    tableSortByEnable: YD_EVENT_CATEGORY + "_SortBy_Click",
    tableSortByPlacementTestClick: YD_EVENT_CATEGORY + "_SortByPT_Click",
    tableSortByGradeLevelClick: YD_EVENT_CATEGORY + "_SortByCGL_Click",
    tableSortByTimeSpentClick: YD_EVENT_CATEGORY + "_SortByTS_Click",
    tableSortByStudentsNameClick: YD_EVENT_CATEGORY + "_SortBySN_Click",
    studentLinkClick: YD_EVENT_CATEGORY + "_StudentName_Click",
    ptResultHover: YD_EVENT_CATEGORY + "_Results_PT_Hover",
    moyResultHover: YD_EVENT_CATEGORY + "_Results_MOY_Hover",
    eoyResultHover: YD_EVENT_CATEGORY + "_Results_EOY_Hover",
    growthHover: YD_EVENT_CATEGORY + "_Growth_Hover",
    downloadReportClick: YD_EVENT_CATEGORY + "_DownloadReport",
};
var useYearlyDashboardAnalytics = function () {
    return useFeatureGoogleAnalytics(YD_EVENT_CATEGORY);
};
export { useYearlyDashboardAnalytics, YearlyDashboardEvents };
